import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpProviderService } from '@fpx/core';
import { DialogService } from 'src/app/fpx-core/services/dialog/dialog.service';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/common.service';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { InfoPopupComponent } from 'src/app/core/components/popup/info-popup/info-popup.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomerService } from 'src/app/services/customer.service';
import { UserService } from 'src/app/user.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsResultPageService {
  resultSubmittedData:any[] = [];
  constructor(
    private _customerService: CustomerService,
    private _http: HttpProviderService,
    private _router: Router,
    public _dialogService: DialogService,
    private _userService: UserService,
    private _commonService: CommonService,
    private dialogRef: MatDialogRef<InfoPopupComponent>,
    private _dialog: MatDialog,
  ) { }



  resetTransfersResultPage(){
    this.resultSubmittedData = []
  }

  }